import { combineReducers } from 'redux';

import airports from './airports';
import error from './error';
import location from './location';
import modal from './modal';
import settings from './settings';
import initiatives from './initiatives';

export const reducers = {
  airports,
  error,
  location,
  modal,
  settings,
  initiatives,
};

export default combineReducers(reducers);
